// context/SocketContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux"; // ✅ get userId from Redux
import { getSocket, disconnectSocket } from "../screens/socket";

const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
  const userId = useSelector((state) => state.Auth.id); // adjust as per your store
  const [socket, setSocket] = useState(null);

  // console.log("userId -- 686aaaf5a1f333b4780a479b",userId)

  useEffect(() => {
    if (!userId) return;

    const sock = getSocket(userId);
    setSocket(sock);

    sock.on("connect", () => {
      console.log("✅ Connected:", sock.id);
    });

    

    sock.on("disconnect", () => {
      console.log("❌ Disconnected");
    });

    return () => {
      disconnectSocket();
    };
  }, [userId]);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
